<script>
    // import { onMount } from 'svelte';
    import Swal from 'sweetalert2';
    import { createEventDispatcher } from 'svelte';
    import { texts } from './texts.js';
    //import MapsLog from './MapsLog.svelte';
    export let round;
    export let lang;
    const dispatch = createEventDispatcher();
    // export let maps;
    export let boyChoice;
    export let girlChoice;
    export let trainerHurried = false;
    //export let mapChoice;
    export let decisions;
    // export let userName;
    export let teamName;
    export let isRoundOn = false;
    export let confirmButtonLabel = 'Potwierdzam!';
    // export let teamColour;
    // export let wantMap = false;
    export const tools = {
        cleanUp() {
            // console.log('cleaning started!');
            boyChoice = '';
            girlChoice = '';
        },
        otherPlayerDecided(boy, girl) {
            boyChoice = boy;
            girlChoice = girl || '';
        },
    };
    const teams = {
        teamA: 'pomaranczowi',
        teamB: 'zieloni',
        teamC: 'niebiescy',
        teamD: 'fioletowi',
        trener: 'trener',
    };

    function playerDecided() {
        if (round > 3) {
            if (!boyChoice || !girlChoice) {
                Swal.fire({
                    icon: 'warning',
                    title: texts[lang].popup_make_decision,
                });
                return;
            }
        } else {
            if (!boyChoice) {
                Swal.fire({
                    icon: 'warning',
                    title: texts[lang].popup_make_decision_before_ines,
                });
                return;
            }
            girlChoice = 'bez_inez';
        }

        let data = {
            nick: teamName,
            chlopiec: boyChoice,
            dziewczynka: girlChoice,
        };
        dispatch('decision-made', data);
    }
    $: isRoundOn
        ? (confirmButtonLabel = texts[lang].confirm)
        : (confirmButtonLabel = texts[lang].please_wait);
</script>

<div class="flex-container">
    <form id="player_choice">
        <div class="item">
            <div class="tooltip">
                <label for="wybor1"
                    >{texts[lang].pirate_header}
                    <span class="tooltiptext"
                        >{texts[lang].pirate_explanation_part1}<i
                            class="fas fa-coins"
                        />{texts[lang].pirate_explanation_part2}<i
                            class="fas fa-coins"
                        />{texts[lang].pirate_explanation_part3}</span
                    >
                    <input
                        type="radio"
                        id="wybor1"
                        name="chlopiec"
                        value="pirat"
                        class="visually-hidden"
                        bind:group={boyChoice}
                        disabled={decisions[teamName] === 'ok'}
                    />
                    <div class="control-me1" />
                </label>
            </div>
            <div class="tooltip">
                <label for="wybor2"
                    >{texts[lang].explorer_header}
                    <span class="tooltiptext"
                        >{texts[lang].explorer_explanation_part1}<i
                            class="fas fa-coins"
                        /></span
                    >
                    <input
                        type="radio"
                        id="wybor2"
                        name="chlopiec"
                        value="odkrywca"
                        class="visually-hidden"
                        bind:group={boyChoice}
                        disabled={decisions[teamName] === 'ok'}
                    />
                    <div class="control-me2" />
                </label>
            </div>
        </div>
        {#if round > 3}
            <div class="item">
                <div class="tooltip">
                    <label for="wybor3"
                        >{texts[lang].black_ines_header}
                        <span class="tooltiptext"
                            >{texts[lang].black_ines_explanation_part1}<i
                                class="fas fa-coins"
                            />{texts[lang].black_ines_explanation_part2}
                        </span>
                        <input
                            type="radio"
                            id="wybor3"
                            name="dziewczynka"
                            value="czarna_inez"
                            class="visually-hidden"
                            bind:group={girlChoice}
                            disabled={decisions[teamName] === 'ok'}
                        />
                        <div class="control-me3" />
                    </label>
                </div>
                <div class="tooltip">
                    <label for="wybor4"
                        >{texts[lang].no_ines_header}
                        <span class="tooltiptext"
                            >{texts[lang].no_ines_explanation_part1}</span
                        >
                        <input
                            type="radio"
                            id="wybor4"
                            name="dziewczynka"
                            value="bez_inez"
                            class="visually-hidden"
                            bind:group={girlChoice}
                            disabled={decisions[teamName] === 'ok'}
                        />
                        <div class="control-me4" />
                    </label>
                </div>
            </div>
        {/if}
        <button
            class="message_form_button"
            class:pulsing_button={trainerHurried &&
                decisions[teamName] !== 'ok'}
            on:click|preventDefault={playerDecided}
            disabled={decisions[teamName] === 'ok' || !isRoundOn}
            >{confirmButtonLabel}</button
        >
    </form>
</div>
